import { module } from "angular";
import angularDragDrop from "angular-drag-drop";
import dndList from "@gtmhub/shared/components/dnd-list/dnd-list.module";
import { GridComponent } from "./grid.component";

const mod = module("ghGrid", [dndList, angularDragDrop]);
mod.component("ghGrid", GridComponent);
export default mod.name;
